import { Superficie_anteproyecto } from './../../../models/superficie_anteproyecto.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-superficie_anteproyecto",
    templateUrl: "./superficie_anteproyecto.component.html",
    styleUrls: ["./superficie_anteproyecto.component.css"],
    providers: [FormService]
})
export class Superficie_anteproyectoComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public superficie_anteproyecto: Superficie_anteproyecto;
    public form;
    public idForm;

    public num;

    public form111;
    public form112;
    public form113;
    public form114;
    public form115;

    public form131;
    public form132;
    public form133;

    public form211;
    public form212;
    public form213;
    public form214;

    public form231
    public form232
    public form233
    public form234
    public form235

    public form251;
    public form252;
    public form253;
    public form254;
    public form255;

    public matcher = new FormService();


    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.idForm = localStorage.getItem("form");


        if (this.idForm == "1-1.1") {
            this.form111 = true;
            this.num = "6.1";
        }
        if (this.idForm == "1-1.2") {
            this.form112 = true;
            this.num = "6.2";
        }
        if (this.idForm == "1-1.3") {
            this.form113 = true;
            this.num = "6.1";
        }
        if (this.idForm == "1-1.4") {
            this.form114 = true;
            this.num = "6.1";
        }
        if (this.idForm == "1-1.5") {
            this.form115 = true;
            this.num = "6.5";
        }

        if (this.idForm == "1-3.1") {
            this.form131 = true;
            this.num = "6.1";
        }
        if (this.idForm == "1-3.2") {
            this.form132 = true;
        }
        if (this.idForm == "1-3.3") {
            this.form133 = true;
        }


        if (this.idForm == "2-1.1") {
            this.form211 = true
        }

        if (this.idForm == "2-1.2") {
            this.form212 = true
        }
        if (this.idForm == "2-1.3") {
            this.form213 = true
        }
        if (this.idForm == "2-1.4") {
            this.form214 = true
        }
        if (this.idForm == "2-3.1") {
            this.form231 = true;
        }
        if (this.idForm == "2-3.2") {
            this.form232 = true;
        }
        if (this.idForm == "2-3.3") {
            this.form233 = true;
        }
        if (this.idForm == "2-3.4") {
            this.form234 = true;
        }
        if (this.idForm == "2-3.5") {
            this.form235 = true;
        }
        if (this.idForm == "2-5.1") {
            this.form251 = true;
        }
        if (this.idForm == "2-5.2") {
            this.form252 = true;
        }
        if (this.idForm == "2-5.3") {
            this.form253 = true;
        }
        if (this.idForm == "2-5.4") {
            this.form254 = true;
        }
        if (this.idForm == "2-5.5") {
            this.form255 = true;
        }


        this.form = new FormGroup({
            totalViviendaE: new FormControl(''),
            sub1: new FormControl(''),
            piso1: new FormControl(''),
            piso2: new FormControl(''),
            piso3: new FormControl(''),

            /* permiso anterior */
            util1: new FormControl(0),
            comun1: new FormControl(0),
            total1: new FormControl(0),
            util2: new FormControl(0),
            comun2: new FormControl(0),
            total2: new FormControl(0),
            util3: new FormControl(0),
            comun3: new FormControl(0),
            total3: new FormControl(0),
            /* ampliacion */
            util1Ampliacion: new FormControl(0),
            comun1Ampliacion: new FormControl(0),
            total1Ampliacion: new FormControl(0),
            util2Ampliacion: new FormControl(0),
            comun2Ampliacion: new FormControl(0),
            total2Ampliacion: new FormControl(0),
            util3Ampliacion: new FormControl(0),
            comun3Ampliacion: new FormControl(0),
            total3Ampliacion: new FormControl(0),
            /* total incluida ampliacion */
            util1Final: new FormControl(0),
            comun1Final: new FormControl(0),
            total1Final: new FormControl(0),
            util2Final: new FormControl(0),
            comun2Final: new FormControl(0),
            total2Final: new FormControl(0),
            util3Final: new FormControl(0),
            comun3Final: new FormControl(0),
            total3Final: new FormControl(0),

            superficiePrimerPisoA: new FormControl(0),
            superficieOcupacion: new FormControl(0),
            superficieOcupacion2: new FormControl(0),
            superficieOcupacionTotal: new FormControl(0),
            superficieTotal: new FormControl(0),

            modificacion_mantiene: new FormControl(''),
            modificacion_disminuye: new FormControl(''),
            modificacion_aumenta: new FormControl(''),
            rec_mantienePermiso: new FormControl(0),

            aumentaSuperficie: new FormControl(''),
            disminuyeSuperficie: new FormControl('')
        })

        if (!JSON.parse(localStorage.getItem("superficie_anteproyecto"))) {
            localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("superficie_anteproyecto"));
            this.form.controls['totalViviendaE'].setValue(this.rows[0] ? this.rows[0].totalViviendaE : '')
            this.form.controls['sub1'].setValue(this.rows[0] ? this.rows[0].sub1 : '')
            this.form.controls['piso1'].setValue(this.rows[0] ? this.rows[0].piso1 : '')
            this.form.controls['piso2'].setValue(this.rows[0] ? this.rows[0].piso2 : '')
            this.form.controls['piso3'].setValue(this.rows[0] ? this.rows[0].piso3 : '')
            /* permiso anterior */
            this.form.controls['util1'].setValue(this.rows[0] ? this.rows[0].util1 : 0)
            this.form.controls['comun1'].setValue(this.rows[0] ? this.rows[0].comun1 : 0)
            this.form.controls['total1'].setValue(this.rows[0] ? this.rows[0].total1 : 0)
            this.form.controls['util2'].setValue(this.rows[0] ? this.rows[0].util2 : 0)
            this.form.controls['comun2'].setValue(this.rows[0] ? this.rows[0].comun2 : 0)
            this.form.controls['total2'].setValue(this.rows[0] ? this.rows[0].total2 : 0)
            this.form.controls['util3'].setValue(this.rows[0] ? this.rows[0].util3 : 0)
            this.form.controls['comun3'].setValue(this.rows[0] ? this.rows[0].comun3 : 0)
            this.form.controls['total3'].setValue(this.rows[0] ? this.rows[0].total3 : 0)
            /* ampliacion */
            this.form.controls['util1Ampliacion'].setValue(this.rows[0] ? this.rows[0].util1Ampliacion : 0)
            this.form.controls['comun1Ampliacion'].setValue(this.rows[0] ? this.rows[0].comun1Ampliacion : 0)
            this.form.controls['total1Ampliacion'].setValue(this.rows[0] ? this.rows[0].total1Ampliacion : 0)
            this.form.controls['util2Ampliacion'].setValue(this.rows[0] ? this.rows[0].util2Ampliacion : 0)
            this.form.controls['comun2Ampliacion'].setValue(this.rows[0] ? this.rows[0].comun2Ampliacion : 0)
            this.form.controls['total2Ampliacion'].setValue(this.rows[0] ? this.rows[0].total2Ampliacion : 0)
            this.form.controls['util3Ampliacion'].setValue(this.rows[0] ? this.rows[0].util3Ampliacion : 0)
            this.form.controls['comun3Ampliacion'].setValue(this.rows[0] ? this.rows[0].comun3Ampliacion : 0)
            this.form.controls['total3Ampliacion'].setValue(this.rows[0] ? this.rows[0].total3Ampliacion : 0)
            /* total incluida ampliacion */
            this.form.controls['util1Final'].setValue(this.rows[0] ? this.rows[0].util1Final : 0)
            this.form.controls['comun1Final'].setValue(this.rows[0] ? this.rows[0].comun1Final : 0)
            this.form.controls['total1Final'].setValue(this.rows[0] ? this.rows[0].total1Final : 0)
            this.form.controls['util2Final'].setValue(this.rows[0] ? this.rows[0].util2Final : 0)
            this.form.controls['comun2Final'].setValue(this.rows[0] ? this.rows[0].comun2Final : 0)
            this.form.controls['total2Final'].setValue(this.rows[0] ? this.rows[0].total2Final : 0)
            this.form.controls['util3Final'].setValue(this.rows[0] ? this.rows[0].util3Final : 0)
            this.form.controls['comun3Final'].setValue(this.rows[0] ? this.rows[0].comun3Final : 0)
            this.form.controls['total3Final'].setValue(this.rows[0] ? this.rows[0].total3Final : 0)

            this.form.controls['superficiePrimerPisoA'].setValue(this.rows[0] ? this.rows[0].superficiePrimerPisoA : 0)
            this.form.controls['superficieOcupacion'].setValue(this.rows[0] ? this.rows[0].superficieOcupacion : 0)
            this.form.controls['superficieOcupacion2'].setValue(this.rows[0] ? this.rows[0].superficieOcupacion2 : 0)
            this.form.controls['superficieOcupacionTotal'].setValue(this.rows[0] ? this.rows[0].superficieOcupacionTotal : 0)
            this.form.controls['superficieTotal'].setValue(this.rows[0] ? this.rows[0].superficieTotal : 0)

            this.form.controls['modificacion_mantiene'].setValue(this.rows[0] ? this.rows[0].modificacion_mantiene : '')
            this.form.controls['modificacion_disminuye'].setValue(this.rows[0] ? this.rows[0].modificacion_disminuye : '')
            this.form.controls['modificacion_aumenta'].setValue(this.rows[0] ? this.rows[0].modificacion_aumenta : '')
            this.form.controls['rec_mantienePermiso'].setValue(this.rows[0] ? this.rows[0].rec_mantienePermiso : 0)

            this.form.controls['aumentaSuperficie'].setValue(this.rows[0] ? this.rows[0].aumentaSuperficie : '')
            this.form.controls['disminuyeSuperficie'].setValue(this.rows[0] ? this.rows[0].disminuyeSuperficie : '')
        }

        this.superficie_anteproyecto = {
              totalViviendaE: '',
            sub1: '',
            piso1: '',
            piso2: '',
            piso3: '',
            /* permiso anterior */
            util1: 0,
            comun1: 0,
            total1: 0,
            util2: 0,
            comun2: 0,
            total2: 0,
            util3: 0,
            comun3: 0,
            total3: 0,
            /* ampliacion */
            util1Ampliacion: 0,
            comun1Ampliacion: 0,
            total1Ampliacion: 0,
            util2Ampliacion: 0,
            comun2Ampliacion: 0,
            total2Ampliacion: 0,
            util3Ampliacion: 0,
            comun3Ampliacion: 0,
            total3Ampliacion: 0,
            /* total incluida ampliacion */
            util1Final: 0,
            comun1Final: 0,
            total1Final: 0,
            util2Final: 0,
            comun2Final: 0,
            total2Final: 0,
            util3Final: 0,
            comun3Final: 0,
            total3Final: 0,

            superficiePrimerPisoA: 0,
            superficieOcupacion: 0,
            superficieOcupacion2: 0,
            superficieOcupacionTotal: 0,
            superficieTotal: 0,

            modificacion_mantiene: '',
            modificacion_disminuye: '',
            modificacion_aumenta: '',
            rec_mantienePermiso: 0,

            aumentaSuperficie: '',
            disminuyeSuperficie: '',
        };


    }

    isChecked = false;

    lastEditedField: string | null = null;

    // Método para registrar el campo que se está editando
    registerFieldEdit(field: string): void {
        this.lastEditedField = field;
    }


    ngOnInit() {
        this.form.valueChanges.subscribe(() => {
            const util1 = this.form.get('util1') ? this.form.get('util1')!.value : 0;
            const comun1 = this.form.get('comun1') ? this.form.get('comun1')!.value : 0;
            const total1 = (util1 || 0) + (comun1 || 0);
            if (this.form.get('total1')) this.form.get('total1')!.setValue(total1, { emitEvent: false });

            const util2 = this.form.get('util2') ? this.form.get('util2')!.value : 0;
            const comun2 = this.form.get('comun2') ? this.form.get('comun2')!.value : 0;
            const total2 = (util2 || 0) + (comun2 || 0);
            if (this.form.get('total2')) this.form.get('total2')!.setValue(total2, { emitEvent: false });

            const util3 = this.form.get('util3') ? this.form.get('util3')!.value : 0;
            const comun3 = this.form.get('comun3') ? this.form.get('comun3')!.value : 0;
            const total3 = (util3 || 0) + (comun3 || 0);
            if (this.form.get('total3')) this.form.get('total3')!.setValue(total3, { emitEvent: false });

            const util1Ampliacion = this.form.get('util1Ampliacion') ? this.form.get('util1Ampliacion')!.value : 0;
            const comun1Ampliacion = this.form.get('comun1Ampliacion') ? this.form.get('comun1Ampliacion')!.value : 0;
            const total1Ampliacion = (util1Ampliacion || 0) + (comun1Ampliacion || 0);
            if (this.form.get('total1Ampliacion')) this.form.get('total1Ampliacion')!.setValue(total1Ampliacion, { emitEvent: false });

            const util2Ampliacion = this.form.get('util2Ampliacion') ? this.form.get('util2Ampliacion')!.value : 0;
            const comun2Ampliacion = this.form.get('comun2Ampliacion') ? this.form.get('comun2Ampliacion')!.value : 0;
            const total2Ampliacion = (util2Ampliacion || 0) + (comun2Ampliacion || 0);
            if (this.form.get('total2Ampliacion')) this.form.get('total2Ampliacion')!.setValue(total2Ampliacion, { emitEvent: false });

            const util3Ampliacion = this.form.get('util3Ampliacion') ? this.form.get('util3Ampliacion')!.value : 0;
            const comun3Ampliacion = this.form.get('comun3Ampliacion') ? this.form.get('comun3Ampliacion')!.value : 0;
            const total3Ampliacion = (util3Ampliacion || 0) + (comun3Ampliacion || 0);
            if (this.form.get('total3Ampliacion')) this.form.get('total3Ampliacion')!.setValue(total3Ampliacion, { emitEvent: false });

            const util1Final = this.form.get('util1Final') ? this.form.get('util1Final')!.value : 0;
            const comun1Final = this.form.get('comun1Final') ? this.form.get('comun1Final')!.value : 0;
            const total1Final = (util1Final || 0) + (comun1Final || 0);
            if (this.form.get('total1Final')) this.form.get('total1Final')!.setValue(total1Final, { emitEvent: false });

            const util2Final = this.form.get('util2Final') ? this.form.get('util2Final')!.value : 0;
            const comun2Final = this.form.get('comun2Final') ? this.form.get('comun2Final')!.value : 0;
            const total2Final = (util2Final || 0) + (comun2Final || 0);
            if (this.form.get('total2Final')) this.form.get('total2Final')!.setValue(total2Final, { emitEvent: false });

            const util3Final = this.form.get('util3Final') ? this.form.get('util3Final')!.value : 0;
            const comun3Final = this.form.get('comun3Final') ? this.form.get('comun3Final')!.value : 0;
            const total3Final = (util3Final || 0) + (comun3Final || 0);
            if (this.form.get('total3Final')) this.form.get('total3Final')!.setValue(total3Final, { emitEvent: false });
        });
    }


    async add_superficie_anteproyecto() {

        this.form.controls['util1'].setValue((this.form.value.util1))
        this.form.controls['comun1'].setValue((this.form.value.comun1))
        this.form.controls['total1'].setValue((this.form.value.total1))
        this.form.controls['util2'].setValue((this.form.value.util2))
        this.form.controls['comun2'].setValue((this.form.value.comun2))
        this.form.controls['total2'].setValue((this.form.value.total2))
        this.form.controls['util3'].setValue((this.form.value.util3))
        this.form.controls['comun3'].setValue((this.form.value.comun3))
        this.form.controls['total3'].setValue((this.form.value.total3))
        this.form.controls['util1Ampliacion'].setValue((this.form.value.util1Ampliacion))
        this.form.controls['comun1Ampliacion'].setValue((this.form.value.comun1Ampliacion))
        this.form.controls['total1Ampliacion'].setValue((this.form.value.total1Ampliacion))
        this.form.controls['util2Ampliacion'].setValue((this.form.value.util2Ampliacion))
        this.form.controls['comun2Ampliacion'].setValue((this.form.value.comun2Ampliacion))
        this.form.controls['total2Ampliacion'].setValue((this.form.value.total2Ampliacion))
        this.form.controls['util3Ampliacion'].setValue((this.form.value.util3Ampliacion))
        this.form.controls['comun3Ampliacion'].setValue((this.form.value.comun3Ampliacion))
        this.form.controls['total3Ampliacion'].setValue((this.form.value.total3Ampliacion))
        this.form.controls['util1Final'].setValue((this.form.value.util1Final))
        this.form.controls['comun1Final'].setValue((this.form.value.comun1Final))
        this.form.controls['total1Final'].setValue((this.form.value.total1Final))
        this.form.controls['util2Final'].setValue((this.form.value.util2Final))
        this.form.controls['comun2Final'].setValue((this.form.value.comun2Final))
        this.form.controls['total2Final'].setValue((this.form.value.total2Final))
        this.form.controls['util3Final'].setValue((this.form.value.util3Final))
        this.form.controls['comun3Final'].setValue((this.form.value.comun3Final))
        this.form.controls['total3Final'].setValue((this.form.value.total3Final))
        this.form.controls['superficiePrimerPisoA'].setValue((this.form.value.superficiePrimerPisoA))
        this.form.controls['superficieOcupacion'].setValue((this.form.value.superficieOcupacion))
        this.form.controls['superficieOcupacion2'].setValue((this.form.value.superficieOcupacion2))
        this.form.controls['superficieOcupacionTotal'].setValue((this.form.value.superficieOcupacionTotal))
        this.form.controls['superficieTotal'].setValue((this.form.value.superficieTotal))
        const valorSeleccionado = this.form.controls['modificacion_mantiene'].setValue(this.form.value.modificacion_mantiene)
        this.form.controls['modificacion_disminuye'].setValue(this.form.value.modificacion_disminuye)
        this.form.controls['modificacion_aumenta'].setValue(this.form.value.modificacion_aumenta)
        this.form.controls['rec_mantienePermiso'].setValue(this.form.value.rec_mantienePermiso)
        this.form.controls['aumentaSuperficie'].setValue(this.form.value.aumentaSuperficie)
        this.form.controls['disminuyeSuperficie'].setValue(this.form.value.disminuyeSuperficie)
        if (!this.form.value.aumentaSuperficie) this.form.controls['modificacion_aumenta'].setValue("")
        if (!this.form.value.disminuyeSuperficie) this.form.controls['modificacion_disminuye'].setValue("")
        localStorage.setItem("superficie_anteproyecto", JSON.stringify([]));
        this.actualRow = localStorage.getItem("superficie_anteproyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
              totalViviendaE: this.form.value.totalViviendaE,
            sub1: this.form.value.sub1,
            piso1: this.form.value.piso1,
            piso2: this.form.value.piso2,
            piso3: this.form.value.piso3,
            
            /* permiso anterior */
            util1: this.form.value.util1,
            comun1: this.form.value.comun1,
            total1: this.form.value.total1,
            util2: this.form.value.util2,
            comun2: this.form.value.comun2,
            total2: this.form.value.total2,
            util3: this.form.value.util3,
            comun3: this.form.value.comun3,
            total3: this.form.value.total3,
            /* ampliacion */
            util1Ampliacion: this.form.value.util1Ampliacion,
            comun1Ampliacion: this.form.value.comun1Ampliacion,
            total1Ampliacion: this.form.value.total1Ampliacion,
            util2Ampliacion: this.form.value.util2Ampliacion,
            comun2Ampliacion: this.form.value.comun2Ampliacion,
            total2Ampliacion: this.form.value.total2Ampliacion,
            util3Ampliacion: this.form.value.util3Ampliacion,
            comun3Ampliacion: this.form.value.comun3Ampliacion,
            total3Ampliacion: this.form.value.total3Ampliacion,
            /* total incluida ampliacion */
            util1Final: this.form.value.util1Final,
            comun1Final: this.form.value.comun1Final,
            total1Final: this.form.value.total1Final,
            util2Final: this.form.value.util2Final,
            comun2Final: this.form.value.comun2Final,
            total2Final: this.form.value.total2Final,
            util3Final: this.form.value.util3Final,
            comun3Final: this.form.value.comun3Final,
            total3Final: this.form.value.total3Final,

            superficiePrimerPisoA: this.form.value.superficiePrimerPisoA,
            superficieOcupacion: this.form.value.superficieOcupacion,
            superficieOcupacion2: this.form.value.superficieOcupacion2,
            superficieOcupacionTotal: this.form.value.superficieOcupacionTotal,
            superficieTotal: this.form.value.superficieTotal,

            modificacion_mantiene: this.form.value.modificacion_mantiene,
            modificacion_disminuye: this.form.value.modificacion_disminuye,
            modificacion_aumenta: this.form.value.modificacion_aumenta,

            rec_mantienePermiso: this.form.value.rec_mantienePermiso,

            aumentaSuperficie: this.form.value.aumentaSuperficie,
            disminuyeSuperficie: this.form.value.disminuyeSuperficie
        })

        localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
        this.isChecked = valorSeleccionado === 'SI' ? true : valorSeleccionado === 'NO' ? false : this.isChecked;
    }
    delete_superficie_anteproyecto(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("superficie_anteproyecto", JSON.stringify(this.rows));
            }
        }
    }

    asyncFormater(text: string): Promise<string> {
        let textFormat = text.replace(/\./g, ",");
        let arrText = textFormat.split(",");
        let textF = ""

        return new Promise((resolve, reject) => {
            let cont = 0
            for (let i = 0; i < arrText.length; i++) {
                const el = arrText[i];
                if (i == 0) {
                    textF = textF + el + ",";
                } else {
                    textF = textF + el
                }
                cont++
                if (cont == arrText.length) {
                    resolve(textF);
                }
            }

        })
    }


}